import { loadScript, hasScript, attacScript } from "./../helpers"

/**
 * init the data lyer of ga, needed to queue analytics and setting up
 * custom dimensions
 */
const initDataLayer = function({trackingId}) {
  const source = `window.dataLayer = window.dataLayer || [];
  function gtag() {
      dataLayer.push(arguments);
  };
  gtag('js', new Date());
  gtag('config', '${trackingId}', {
      custom_map: {
          'dimension1': 'viewer_language',
          'dimension2': 'asset_id'
      }
  });`
  attacScript(source)
}

const optionsDefaults = {
  trackingURL: 'https://www.googletagmanager.com/gtag/js?id='
}

const tracker = function (opts) {
  return {
    options: opts,
    trackTag({action, category, label, value, language}) {
      /* global gtag */
      gtag('event', action, {
        'event_category': category,
        'event_label': label,
        'viewer_language': language,
        'value': value,
        'asset_id': this.options.assetTitle || this.options.assetId
    });
    }
  }
}

/**
 * lazy loading of ga script if needed
 */
const init = function({trackingURL, trackingId}) {
    if (!hasScript()) {
      const url = trackingURL + trackingId
      loadScript(url)
      initDataLayer({
        trackingId
      })
    }
}

export default {
  install(VueRoot, opts) {
    console.log('ga plugin')
    const options = { ...optionsDefaults, ...opts }
    if (!options.trackingURL || !options.trackingId) {
      throw new Error('trackingURL and trackingId are required');
    }
    init(options)
    VueRoot.$ga = VueRoot.$ga = tracker(options)
  }
}
